import { baseClasses } from '@weatherbug/common';
import { FavoriteLocationsProvider } from '../providers/favoriteLocationsProvider';

const { AsyncAction } = baseClasses;

export const GET_ALL_FAVORITE_LOCATIONS = new AsyncAction('GET_ALL_FAVORITE_LOCATIONS');
export const CREATE_FAVORITE_LOCATION = new AsyncAction('CREATE_FAVORITE_LOCATION');
export const UPDATE_FAVORITE_LOCATION = new AsyncAction('UPDATE_FAVORITE_LOCATION');
export const DELETE_FAVORITE_LOCATION = new AsyncAction('DELETE_FAVORITE_LOCATION');
export const PROCESS_FAVORITES_FROM_DIRECTIVE = 'PROCESS_FAVORITES_FROM_DIRECTIVE';

export function getAllFavoriteLocations(refresh) {
    return {
        type: GET_ALL_FAVORITE_LOCATIONS.base,
        payload: getAllFavoriteLocationsAction(refresh)
    };
}

async function getAllFavoriteLocationsAction(refresh) {
    const op = new FavoriteLocationsProvider();
    return await op.getAllFavoriteLocations(refresh);
}

export function createFavoriteLocation(location) {
    return {
        type: CREATE_FAVORITE_LOCATION.base,
        payload: createFavoriteLocationAction(location)
    };
}

async function createFavoriteLocationAction(location) {
    const op = new FavoriteLocationsProvider();
    return await op.createFavoriteLocation(location);
}

export function updateFavoriteLocation(location) {
    return {
        type: UPDATE_FAVORITE_LOCATION.base,
        payload: updateFavoriteLocationAction(location)
    };
}

async function updateFavoriteLocationAction(location) {
    const op = new FavoriteLocationsProvider();
    return await op.updateFavoriteLocation(location);
}

export function deleteFavoriteLocation(location) {
    return {
        type: DELETE_FAVORITE_LOCATION.base,
        payload: deleteFavoriteLocationAction(location)
    };
}

async function deleteFavoriteLocationAction(location) {
    const op = new FavoriteLocationsProvider();
    return await op.deleteFavoriteLocation(location);
}

// TECHDEBT remove when we convert the popup to React
export function processFavoritesFromDirective(locations) {
    return {
        type: PROCESS_FAVORITES_FROM_DIRECTIVE,
        payload: locations
    };
}
